import { type SalesFunnelData, useFunnelData } from 'utils/funnel-data-context';
import MultiBundleItem from './components/MultiBundleItem';

import type { ComponentsMultiBundle } from 'queries/graphql';

import styles from './styles.module.scss';

export default function MultiBundle({
  sectionId,
  offers,
  afterpayWidget,
  showProductPrice,
  style,
}: ComponentsMultiBundle) {
  const { isAfterpaySupported } = useFunnelData<SalesFunnelData>();

  return (
    <div id={sectionId} className={styles.container} data-cy="multi-bundle">
      {offers.map(offer => (
        <MultiBundleItem
          key={offer.salesPageOfferId}
          {...offer}
          afterpayWidget={afterpayWidget}
          isAfterpaySupported={isAfterpaySupported}
          style={style}
          showProductUnitPrice={showProductPrice}
        />
      ))}
    </div>
  );
}
